import {makeStyles} from "@material-ui/core/styles";
import {grey} from "@material-ui/core/colors";
import {useTranslation} from "react-i18next";
import React, {Fragment} from "react";
import {Typography} from "@material-ui/core";

export const useStyles = makeStyles(() => ({
    pending: {
        color: grey[500],
        fontStyle: 'italic'
    }
}));

export const ContactStatus = ({
    status
}: any) => {
    const {t} = useTranslation();
    const classes = useStyles();
       return (<Fragment>
                {status === 0 ? <Typography className={classes.pending}>{t('Machine.Contacts.Status.Pending')}</Typography> :
                       <Typography>{t('Machine.Contacts.Status.Accepted')}</Typography>
        }
    </Fragment>)
};
